window.app.factory("newsApi", [
  "apiHelper2",
  function(simpleApi) {
    const newsApi = simpleApi({
      name: "news",
      key: ":articleId",
      baseEndpoint: "news/$/@/",
      defaultMethods: "GL",
      customMethods: {
        getRootArticle: {
          endpoint: "news/$/@/root"
        }
      }
    });

    newsApi.addComment = function(comment) {
      return this.custom({
        endpoint: "news/$/@/" + comment.newsItemId + "/comment",
        method: "POST",
        data: comment
      }).then(article => {
        this.inject(article);
        return article;
      });
    };

    newsApi.flagComment = function(comment) {
      console.warn("Will flag", { comment, itemId: comment.newsItemId });
      return this.custom({
        endpoint: "news/$/@/commentInappropriate/" + comment.commentId,
        method: "POST"
      }).then(() => {
        const article = this.cache.list.find(a => a.id === comment.newsItemId);
        return this.get(
          { articleId: article.articleId },
          { bypassCache: true }
        );
      });
    };

    newsApi.toggleArticleLike = function(id, likeIt) {
      const action = likeIt ? "like" : "unlike";
      return this.custom({
        endpoint: "news/$/@/" + id + (likeIt ? "/like" : "/unlike"),
        method: "POST"
      }).then(() => {
        const article = this.cache.list.find(a => a.id === id);
        console.warn(`cached article being updated (${action}) is`, article);
        return this.get(
          { articleId: article.articleId },
          { bypassCache: true }
        );
      });
    };

    return newsApi;
  }
]);



// WEBPACK FOOTER //
// ./src/apps/news/api/newsApi.js